import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

export default CreateReactClass({
    displayName: 'user-alerts',

    propTypes: {
        pageAlert: PropTypes.instanceOf(Immutable.Map).isRequired,
    },

    render() {
        const alertClass = this.props.pageAlert.get('isActive') ? 'user-alerts active' : 'user-alerts';
        return <div className={alertClass}>{this.props.pageAlert.get('messageContent', null)}</div>;
    },
});
